'use client'

import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import Button from '@/components/Button';
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react';
import { useLocale } from 'next-intl';
import Link from 'next-intl/link';
import Image from "next/image";
import formatUkPhone from "@/app/lib/format-phone";
import { Toaster } from 'react-hot-toast';
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import { getStrapiImageUrl, getStrapiImageWidth, getStrapiImageHeight } from '@/app/lib/util';
import toast from "react-hot-toast";
import LogoWhite from "@/img/logo_white.svg";
import Partnered from "@/img/partnered-with.png";
import PaymentMethods from "@/img/payment-logos.svg"
import {faAngleDown, faAngleUp, faEnvelope, faMobileIphone, IconDefinition} from '@fortawesome/pro-solid-svg-icons';
import { faFacebookF, faInstagram, faLinkedinIn, faXTwitter  } from '@fortawesome/free-brands-svg-icons';
import { NewsletterSignup } from '../lib/api';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { useReCaptcha } from 'next-recaptcha-v3';
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {StrapiMenu, GlobalData} from "@/app/types/strapi.types";


function SocialLink({link, icon, title} : {link: string, icon: IconDefinition, title:string}) {
    return (
        <Link href={link} title={title} className="w-[45px] h-[45px] border-white border rounded flex items-center justify-center text-white">
            <FontAwesomeIcon icon={icon} className="text-2xl" />
        </Link>
    )
}



export default function Footer({footerCompanyMenu, footerHelpMenu, global} : {footerCompanyMenu: StrapiMenu, footerHelpMenu: StrapiMenu, global: GlobalData}) {

    const { executeRecaptcha } = useReCaptcha();

    const locale = useLocale();

    const pathname = usePathname()
    const firstPath = pathname.split("/").at(1);

    if (typeof window !== 'undefined') {
        useEffect(() => {
            if(firstPath == "account" || firstPath == "login" || firstPath == 'forgot-password' || firstPath == 'create-password' || firstPath == "request-verify-email" || firstPath == "verify-account" || pathname == "/business/verify-account") {
                document.body.classList.add('account');
            } else {
                document.body.classList.remove('account');
            }
        }, [document, firstPath, pathname])
    }

    var now = dayjs()
    const year = now.format('YYYY');

    const [showCompanyMenu, setShowCompanyMenu] = useState(false);
    const [showHelpMenu, setShowHelpMenu] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const handleSubmitNewsletter = async (body: unknown) =>  {
		setSubmitting(true)
		try {
			await NewsletterSignup(body).then(() => {
				setSubmitting(false)
				toast.success("Your are now subscribed, thank you!")
			})
		} catch (error) {
			setSubmitting(false)
			toast.error("There was an error subscribing to the newsletter")
		}
	}

    const validationSchema = Yup.object().shape({
        email: Yup.string()
                  .email('Invalid email address')
                  .required('Email is required'),
    });

    return(
        <>
            {firstPath == "account" || firstPath == "login" || firstPath == "forgot-password" || firstPath == "verify-account" || firstPath == "create-account" || firstPath == "request-verify-email" || pathname == "/business/create-account" || pathname == "/business/verify-account"  ? null : (
                <>
                    <section className="bg-[#F9EBE2] py-10 xl:py-16 relative mt-10">
                        <div className="container text-left lg:text-center lg:px-20">
                            <h2 className="text-4xl xl:text-5xl font-bold  mb-6">
                                {global.FooterC2ATitle}
                            </h2>

                            <ReactMarkdown
                                // @ts-expect-error
                                rehypePlugins={[rehypeRaw]}
                                className="leading-7 mb-6 font-medium text-xl"
                            >
                                {global.FooterC2AContent}
                            </ReactMarkdown>

                            <Button link="/how-it-works" class={`px-12 rounded-lg text-xl relative justify-center flex w-full md:w-auto md:inline-flex ${locale == "personal" && "text-white"}`} label="How it works" />
                        </div>
                    </section>
                    <footer className="bg-[#403D44]">
                        <div className="container pt-16 pb-28">
                            <div className="flex items-start justify-start lg:gap-16 flex-wrap lg:flex-nowrap">
                                <div className="w-full lg:w-3/12 order-1 flex flex-col items-center lg:block">
                                    {global.FooterLogo ? (
                                        <Image quality={100} src={getStrapiImageUrl(global.FooterLogo)} width={getStrapiImageWidth(global.FooterLogo)} height={getStrapiImageHeight(global.FooterLogo)} alt="Carecoins" />
                                    ) : (
                                        <Image src={LogoWhite} alt="Carecoins" />
                                    )}

                                    <Image src={Partnered} alt="Partnered with Red Umbrella" />
                                    <div className="flex gap-4 lg:block mt-4 xl:mt-0 mb-8 xl:mb-0">
                                        <div className="lg:mt-4">
                                            <FontAwesomeIcon icon={faMobileIphone} className="text-primary text-sm xl:text-xl mr-2" fixedWidth />
                                            <a href={`tel:${global.TelephoneNumber}`} className="text-white text-sm xl:text-xl">
                                                {formatUkPhone(global.TelephoneNumber)}
                                            </a>
                                        </div>
                                        <div className="lg:mt-2">
                                            <FontAwesomeIcon icon={faEnvelope} className="text-primary text-sm  xl:text-xl mr-2" fixedWidth />
                                            <a href={`mailto:${global.EmailAddress}`} className="text-white text-sm  xl:text-xl">
                                            {global.EmailAddress}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-full lg:w-4/12 order-3 lg:order-2">
                                    <div
                                        onClick={() => setShowCompanyMenu(!showCompanyMenu)}
                                        className="text-primary border-t xl:border-t-0 pt-4 xl:pt-0 xl:border-b pb-4 xl:pb-2 border-[rgba(255,255,255,0.2)] font-medium xl:mb-6 flex items-center justify-between w-full xl:block cursor-pointer xl:cursor-none"
                                    >
                                        <span className="xl:border-b xl:pb-[10px] lg:text-lg xl:border-primary">Company</span>
                                        <div className="lg:hidden">
                                            <FontAwesomeIcon icon={showCompanyMenu ? faAngleUp : faAngleDown} className="xl:hidden" />
                                        </div>
                                    </div>
                                    <div className={`xl:grid-cols-2 gap-x-10 gap-y-2 pl-3 lg:pl-0 ${showCompanyMenu ? "grid mb-4 lg:grid" : "hidden lg:grid"}`}>
                                        {footerCompanyMenu.items.data.map((topLevelMenuItem, index: number) => (
                                            <li key={index} className={"list-none "}>
                                                <Link className="text-white font-light" key={index} href={topLevelMenuItem.attributes.url} title={topLevelMenuItem.attributes.title}>
                                                    {topLevelMenuItem.attributes.title}
                                                </Link>

                                            </li>
                                        ))}
                                    </div>
                                </div>
                                <div className="w-full lg:w-3/12 order-4 lg:order-3">
                                    <div
                                        onClick={() => setShowHelpMenu(!showHelpMenu)}
                                        className="text-primary border-t xl:border-t-0 pt-4 xl:pt-0 xl:border-b pb-4 xl:pb-2 border-[rgba(255,255,255,0.2)] font-medium xl:mb-6 flex items-center justify-between w-full xl:block cursor-pointer xl:cursor-none"
                                    >
                                        <span className="xl:border-b xl:pb-[10px] lg:text-lg xl:border-primary">Help</span>
                                        <div className="lg:hidden">
                                            <FontAwesomeIcon icon={showHelpMenu ? faAngleUp : faAngleDown}  />
                                        </div>
                                    </div>
                                    <div className={`gap-x-10 gap-y-2 pl-3 lg:pl-0 ${showHelpMenu ? "grid mb-4 lg:grid" : "hidden lg:grid"}`}>
                                        {footerHelpMenu.items.data.map((topLevelMenuItem, index: number) => (
                                            <li key={index} className={"list-none "}>
                                                <Link className="text-white font-light" key={index} href={topLevelMenuItem.attributes.url} title={topLevelMenuItem.attributes.title}>
                                                    {topLevelMenuItem.attributes.title}
                                                </Link>
                                            </li>
                                        ))}
                                    </div>
                                </div>
                                <div className="w-full order-2 lg:order-4 lg:w-2/12 flex flex-col items-center lg:block mb-8 lg:mb-0">
                                    <div className="hidden lg:block text-primary border-b pb-2 border-[rgba(255,255,255,0.2)] font-medium mb-6">
                                        <span className="border-b pb-[10px] border-primary">Follow us</span>
                                    </div>
                                    <div className="flex gap-4">
                                        {global.Socials.FacebookLink && (
                                            <SocialLink title="Like us on facebook" link={global.Socials.FacebookLink} icon={faFacebookF as IconDefinition} />
                                        )}
                                        {global.Socials.InstagramLink && (
                                            <SocialLink title="Follow us on Instagram" link={global.Socials.InstagramLink} icon={faInstagram as IconDefinition} />
                                        )}
                                        {global.Socials.LinkedInLink && (
                                            <SocialLink title="Link up with us on LinkedIn" link={global.Socials.LinkedInLink} icon={faLinkedinIn as IconDefinition} />
                                        )}
                                        {global.Socials.XLink && (
                                            <SocialLink title="Follow us on X" link={global.Socials.XLink} icon={faXTwitter as IconDefinition} />
                                        )}
                                    </div>

                                    <div className="block w-full text-primary border-b pb-2 border-[rgba(255,255,255,0.2)] font-medium my-6">
                                        <span className="border-b pb-[10px] border-primary">Newsletter</span>
                                    </div>
                                    <div className="flex flex-col w-full">
                                        <Formik
                                            initialValues={{
                                                "email": "",
                                            }}
                                            validationSchema={validationSchema}
                                            onSubmit={async (values, {resetForm}) => {
                                                const token = await executeRecaptcha('newsletter_signup');
                                                handleSubmitNewsletter({...values, recaptchaToken: token});
                                                resetForm();
                                            }}
                                        >
                                            {({errors}) => (
                                                <Form suppressHydrationWarning={true}>
                                                    <Field placeholder="Email address" type="email" name="email" id="email" required className="w-full text-white border-white appearance-none bg-[#403D44] border h-[45px] flex rounded-md px-4" />

                                                    <Button thin disabled={submitting || errors.email ? true : false} type="submit" class={`bg-[#26242A] h-[45px] text-white px-5 py-0 mt-4 w-full flex items-center justify-center lg:w-auto`} label={submitting ? "Signing up" : "Sign up"} />
                                                </Form>
                                            )}
                                        </Formik>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-[#535057]">
                            <div className="container py-6 flex flex-col md:flex-row items-center justify-between text-white text-sm">
                                <div className="opacity-60 order-2 md:order-1">© {year} Carecoins | All rights reserved</div>
                                <div className="order-1 md:order-2 mb-1 flex flex-row gap-2 items-center">
                                    <span className="opacity-80 font-bold"><FontAwesomeIcon icon={faLock} className="mr-2" />Secure payments</span>
                                    <Image src={PaymentMethods} alt="Powered by stripe" className="min-w-[224px] ml-2" />
                                </div>
                            </div>
                        </div>
                    </footer>
                </>
            )}
            <Toaster

                position="top-right"
                containerStyle={{
                   inset: 25
                }}
                toastOptions={{
                    duration: 3500,
                }}
            />
        </>
    )
}
